const lodash = require('lodash');
const seedrandom = require('seedrandom');
const a = require('./evaluate/A');
const { prepare } = require('./evaluate/prepare');

const evaluate = (code, opts = {}) => {
  const { seed } = opts;
  seedrandom(seed, { global: true });
  const _ = lodash.runInContext();
  const A = a(opts); // eslint-disable-line no-unused-vars
  const bundle = eval(code); // eslint-disable-line no-eval
  return bundle;
};

module.exports = {
  evaluate,
  prepare,
};
